<template>
  <div class="pc-token-tx">
    <div class="total flex-left-stright">
      <span class="tx-count" v-if="addr.length !== 0">按代币持有者筛选</span>
      <div class="adr" v-if="addr.length !== 0">
        <router-link :to="`/address/${addr}`" class="light">{{
          addr | filterHash(20)
        }}</router-link>
        <div class="copy-btn" v-clipboard:copy="addr" v-clipboard:success="success" v-clipboard:error="error">
          复制
        </div>
      </div>
      <span class="tx-count">共找到 {{ pages.total || 0 | filterNum }} 笔交易</span>
      <!-- <div class="account" v-if="addr.length !== 0">
        <i class="iconfont iconshanchu" @click="$emit('clear')"></i>
        <div class="acc-head">
          <i class="iconfont iconzhanghuyue"></i>
          <span>余额</span>
        </div>
        <p>{{ balance | filterNum }} {{ token }}</p>
      </div> -->
    </div>
    <!-- 表格部分 -->
    <el-table :data="Trades" stripe style="width: 100%" class="data-table" :loading="loading">
      <el-table-column :label="$t('trade.hash')">
        <template slot-scope="item">
          <router-link :to="`/tx/${item.row.hash || item.row.tx_hash}`" class="light">
            <i class="iconfont err-ico" :class="{
              'iconjinggao-chucuo':
                item.row.success === false && item.row.is_para === false,
            }"></i>
            {{ (item.row.hash || item.row.tx_hash) | filterHash(10) }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column :label="$t('home.sender')" width="185">
        <template slot-scope="item">
          <router-link :to="`/address/${item.row.from}`" class="light">{{
            item.row.from | filterHash(12)
          }}</router-link>
        </template>
      </el-table-column>
      <el-table-column width="60">
        <template slot-scope="item">
          <i class="iconfont iconjiantou-you"></i>
        </template>
      </el-table-column>
      <el-table-column :label="$t('home.receiver')">
        <template slot-scope="item">
          <router-link :to="`/address/${item.row.to}`" class="light">{{
            item.row.to | filterHash(12)
          }}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="fee" :label="$t('trade.num')" width="130">
        <template slot-scope="item">
          {{ item.row.value_formatted || item.row.value }} {{ item.row.token_symbol || token }}
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('trade.fee')" width="110">
        <template slot-scope="item">-</template>
      </el-table-column>
      <el-table-column :label="$t('trade.func')" width="100">
        <template slot-scope="item">Transfer</template>
      </el-table-column> -->
      <el-table-column label="时间" width="180">
        <template slot-scope="item">{{
          new Date(item.row.block_time).getTime() | formatTime
        }}</template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import TxBase from "@/mixins/TokenDetail/tokenTx.js";
export default {
  mixins: [TxBase],
};
</script>

<style lang="scss">
.pc-token-tx {
  .total {
    position: relative;
    padding: 15px 30px 10px;
    min-height: 90px;
    background: #f9fafc;

    .tx-count {
      font-size: 14px;
      color: $font_grey;
    }

    .adr {
      font-size: 14px;
      margin: 5px 0 20px;
    }

    .account {
      position: absolute;
      width: 225px;
      height: 70px;
      padding-left: 25px;
      top: 12px;
      right: 13px;
      border-left: 1px solid #d6dde0;
      background: rgba(237, 242, 248, 1);

      .iconshanchu {
        float: right;
        color: $black;
        font-size: 20px;
        cursor: pointer;
        transition: 0.3s;
      }

      .iconshanchu:hover {
        opacity: 0.8;
      }

      .acc-head {
        color: $black;
        font-size: 14px;
        margin: 10px 0 8px;

        span {
          margin-left: 10px;
        }
      }

      p {
        color: $black;
        font-size: 17px;
      }
    }
  }

  .data-table {
    border-top: 1px solid #ececec;

    .err-ico {
      color: #e45359;
      font-size: 12px;
      width: 13px;
      margin-right: 5px;
      display: inline-flex;
    }

    .el-table__header thead tr {
      height: 60px;
      color: $font_grey;
    }

    .iconjiantou-you {
      font-size: 20px;
      color: #9aaab9;
    }
  }

  .el-table th:nth-of-type(1) .cell {
    padding-left: 30px;
  }
}
</style>
